import React, { Dispatch, SetStateAction } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import CommonImage from '../CommonImage';
import Row from '../Row';
import Text from '../Text';
import {
  IconChevronDown,
  IconMenu,
  ICON_FRIP_LOGO,
  ICON_MENU_INDIVIDUAL,
  ICON_MENU_LOGOUT,
  ICON_MENU_PROFILE,
} from 'assets/icons';
import {
  DELIVERY_PATH,
  INDIVIDUAL_PATH,
  MENU_PATH,
  NOTICE_PATH,
  PROFILE_PATH,
  QNA_LIST_PATH,
  REVIEW_LIST_PATH,
  SETTLEMENT_PATH,
  SETTLEMENT_REQUEST_PATH,
} from 'constants/path';
import Divider from 'components/Divider';
import MenuItems from './MenuItems';
import ProfileThumbnail from '../ProfileThumbnail';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { MeData } from 'graphQL/Auth/types';
import HackleManager from 'utils/hackle';
import NavigateForm from 'containers/ProductList/components/NavigateForm';
import { HEADER_HEIGHT } from 'constants/style';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  padding: 16px 40px;
  width: 100%;
  height: ${HEADER_HEIGHT}px;

  background: rgba(65, 75, 86, 1);
`;

const MenuButtonBox = styled.ul`
  width: 42px;
  padding: 0;
  margin: 0;

  cursor: pointer;

  li {
    list-style: none;
    width: 42px;
  }
`;

const MenuChevronBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 18px;
  height: 18px;
`;

const ProfileContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  position: relative;
  width: auto;
  cursor: pointer;

  > img {
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;

    border-color: rgba(0, 0, 0, 0.2);
  }
  > svg {
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;
  }
`;

const MyInfoSheet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: absolute;
  right: 0px;
  top: 32px;
  padding: 16px 20px;
  width: 200px;
  border-radius: 12px;
  background: var(--Static-White, #fff);
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
  z-index: 20;
`;

const MENU_LIST = [
  {
    title: '예약',
    path: 'booking',
  },
  {
    title: '판매',
    path: 'sales',
  },
  {
    title: '상품',
    path: 'product',
  },
  {
    title: '메시지',
    path: 'message',
  },
];

interface PCHeaderIProps {
  activeButton: string;
  isOpenMenuSheet: boolean;
  isOpenMyInfoSheet: boolean;
  setIsOpenMyInfoSheet: Dispatch<SetStateAction<boolean>>;
  setIsOpenMenuSheet: Dispatch<SetStateAction<boolean>>;
  handleNavigatePage: (path: string) => void;
  handleSignout: () => void;
}

const PCHeader: React.FC<PCHeaderIProps> = props => {
  const {
    activeButton,
    isOpenMenuSheet,
    isOpenMyInfoSheet,
    setIsOpenMyInfoSheet,
    setIsOpenMenuSheet,
    handleNavigatePage,
    handleSignout,
  } = props;
  const myInfo: MeData = useUserInformation(state => state.userInfo);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const renderMyInfoSheet = (): JSX.Element => {
    return (
      <MyInfoSheet
        onMouseLeave={() => {
          setIsOpenMyInfoSheet(false);
        }}
      >
        <NavigateForm
          icon={ICON_MENU_PROFILE}
          title="프로필 관리"
          onClick={() => {
            navigate(PROFILE_PATH);

            HackleManager.logProfileMenuClick('프로필 관리');
            setIsOpenMyInfoSheet(false);
          }}
          iconStyle={{ width: '18px', height: '18px' }}
        />
        <NavigateForm
          icon={ICON_MENU_INDIVIDUAL}
          title="연락처 설정"
          onClick={() => {
            navigate(INDIVIDUAL_PATH);

            HackleManager.logProfileMenuClick('호스트 연락처 설정');
            setIsOpenMyInfoSheet(false);
          }}
          iconStyle={{ width: '18px', height: '18px' }}
        />
        <Divider />
        <NavigateForm
          icon={ICON_MENU_LOGOUT}
          title="로그아웃"
          onClick={() => {
            handleSignout();
          }}
        />
        {/* <Text
          color="#46474C"
          onClick={() => {
            setIsOpenMyInfoSheet(false);

            HackleManager.logProfileMenuClick('프로필 관리');
            navigate(PROFILE_PATH);
          }}
          style={{ cursor: 'pointer' }}
        >
          프로필 관리
        </Text>
        <Text
          color="#46474C"
          onClick={() => {
            setIsOpenMyInfoSheet(false);

            HackleManager.logProfileMenuClick('호스트 연락처 설정');
            navigate(INDIVIDUAL_PATH);
          }}
          style={{ cursor: 'pointer' }}
        >
          호스트 연락처 설정
        </Text>
        <Divider />
        <Text
          color="#46474C"
          onClick={() => {
            setIsOpenMyInfoSheet(false);
            handleSignout();
          }}
          style={{ cursor: 'pointer' }}
        >
          로그아웃
        </Text> */}
      </MyInfoSheet>
    );
  };

  return (
    <HeaderContainer>
      <Row
        justifyContent="space-between"
        style={{
          padding: '0 40px',
          width: '100%',
          maxWidth: '1280px',
        }}
      >
        <CommonImage
          src={ICON_FRIP_LOGO}
          onClick={() => {
            navigate('/');
            setIsOpenMenuSheet(false);
          }}
        />

        <Row gap="32px" align="flex-start" style={{ width: 'auto' }}>
          {MENU_LIST.map((menu, index) => {
            return (
              <MenuButtonBox
                key={`${index}-${menu.title}-${menu.path}`}
                onClick={() => {
                  handleNavigatePage(menu.path);
                }}
              >
                <li>
                  <Text
                    size="16px"
                    style={{ textAlign: 'center' }}
                    color={
                      activeButton.includes(menu.path)
                        ? 'rgba(255, 255, 255, 1)'
                        : 'rgba(152, 155, 162, 1)'
                    }
                  >
                    {menu.title}
                  </Text>
                </li>
              </MenuButtonBox>
            );
          })}

          <Row
            gap="6px"
            style={{ position: 'relative', cursor: 'pointer' }}
            onClick={() => {
              HackleManager.logMenuClick('메뉴');

              if (isOpenMyInfoSheet) {
                setIsOpenMyInfoSheet(false);
              }

              setIsOpenMenuSheet(!isOpenMenuSheet);
            }}
          >
            <Text
              style={{
                lineHeight: '22px',
              }}
              weight={500}
              size="16px"
              color={
                [
                  MENU_PATH,
                  SETTLEMENT_REQUEST_PATH,
                  NOTICE_PATH,
                  DELIVERY_PATH,
                  REVIEW_LIST_PATH,
                  QNA_LIST_PATH,
                  SETTLEMENT_PATH,
                ].includes(pathname)
                  ? 'rgba(255, 255, 255, 1)'
                  : 'rgba(152, 155, 162, 1)'
              }
            >
              메뉴
            </Text>

            <MenuChevronBox
              style={{
                rotate: isOpenMenuSheet ? '180deg' : '0deg',
                color: '#989BA2',
              }}
            >
              <IconChevronDown />
            </MenuChevronBox>
            {isOpenMenuSheet && (
              <MenuItems
                onClose={() => {
                  setIsOpenMenuSheet(false);
                }}
              />
            )}
          </Row>
        </Row>

        <ProfileContainer
          onClick={() => {
            if (isOpenMenuSheet) {
              setIsOpenMenuSheet(false);
            }

            setIsOpenMyInfoSheet(!isOpenMyInfoSheet);
          }}
        >
          <ProfileThumbnail />
          <IconMenu />

          {isOpenMyInfoSheet && renderMyInfoSheet()}
        </ProfileContainer>
      </Row>
    </HeaderContainer>
  );
};

export default PCHeader;
